'use strict';exports.__esModule = true;var _beautifyNumber = require('../../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _clearNumber = require('../../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _constants = require('../../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

{
  area: function area(value) {return (0, _clearNumber2.default)(value);},
  apartments: function apartments(value, previousValue) {
    if (value) {
      if (value.toString().match(/^(\d{0,4}(\.[0|5]?|[.])?)$/)) {
        return value;
      }
      return previousValue;
    }
    return '';
  },
  rooms: function rooms(value, previousValue) {
    if (value) {
      if (value.toString().match(/^(\d{0,2}(\.[0|5]?|[.])?)$/)) {
        return value;
      }
      return previousValue;
    }
    return '';
  },
  'floor.out_of': function floorOut_of(value, previousValue) {
    if (!value.length || isNaN(value) || +value === 0) {
      return '';
    }
    if (value > 99) {
      return +previousValue;
    }
    return +value;
  },
  'floor.on_the': function floorOn_the(value, previousValue) {
    if (isNaN(value) || value === '') {
      return '';
    }
    if (value > 99) {
      return +previousValue;
    }
    return +value;
  },
  construction_year: function construction_year(value, previousValue) {
    if (isNaN(value)) {
      return undefined;
    }
    if (value > new Date().getFullYear() + 10) {
      return previousValue;
    }
    return value;
  },
  working_since: function working_since(value, previousValue) {
    if (isNaN(value)) {
      return undefined;
    }
    if (value > new Date().getFullYear()) {
      return previousValue;
    }
    return value;
  },
  phone: function phone(value, previousValue) {
    if (value || value === '') {
      if (value.toString().match(_constants.phoneNumberRegex) || !value.length) {
        return value;
      }
      return previousValue;
    }
    return undefined;
  },
  price: function price(value) {return (0, _beautifyNumber2.default)(+(0, _clearNumber2.default)(value));},
  numbers: function numbers(value) {return (0, _clearNumber2.default)(value);},
  description: function description(value) {return value === '' ? undefined : value;},
  date: function date(value) {return value === null ? '' : value;},
  rental: function rental(value, previousValue) {
    if (isNaN(value) || value === '' || +value === 0) {
      return '';
    }
    if (value > 12) {
      return previousValue;
    }
    return value;
  },
  house_number: function house_number(value) {return +value === 0 ? '' : value;} };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/normalizers/publish.js
// module id = 114
// module chunks = 0